module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/gallery/left-arrow-7fab55c04b176de4459e60e3a51f3b9c.png";